import { createReducer, getType } from "typesafe-actions";

import Team from "@mapmycustomers/shared/types/Team";
import User from "@mapmycustomers/shared/types/User";

import RoleFilter from "../../components/PermissionsReport/enum/RoleFilter";

import {
  initializePermissionsReport,
  PermissionsReportActions,
  setPermissionsReportRoleFilter,
  setPermissionsReportSearchQuery,
  setPermissionsReportTeamId,
} from "./actions";

export interface PermissionsReportState {
  failed: boolean;
  loading: boolean;
  roleFilter: RoleFilter;
  searchQuery: string;
  teamId: Team["id"] | undefined;
  users: User[];
}

export const permissionsReportInitialState: PermissionsReportState = {
  failed: false,
  loading: false,
  roleFilter: RoleFilter.ALL,
  searchQuery: "",
  teamId: undefined,
  users: [],
};

const permissionsReport = createReducer<PermissionsReportState, PermissionsReportActions>(
  permissionsReportInitialState
)
  .handleType(getType(initializePermissionsReport.request), (state) => ({
    ...state,
    failed: false,
    loading: true,
  }))
  .handleType(getType(initializePermissionsReport.success), (state, { payload }) => ({
    ...state,
    failed: false,
    loading: false,
    users: payload,
  }))
  .handleType(getType(initializePermissionsReport.failure), (state) => ({
    ...state,
    failed: true,
    loading: false,
    users: [],
  }))
  .handleType(getType(setPermissionsReportRoleFilter), (state, { payload }) => ({
    ...state,
    roleFilter: payload,
  }))
  .handleType(getType(setPermissionsReportSearchQuery), (state, { payload }) => ({
    ...state,
    searchQuery: payload,
  }))
  .handleType(getType(setPermissionsReportTeamId), (state, { payload }) => ({
    ...state,
    teamId: payload,
  }));

export default permissionsReport;
